import { type MaybePromise, noop } from '@amazon/vinyl-util'

export function startViewTransition(cb: () => MaybePromise<any>): Promise<void> {
    if ('startViewTransition' in document) {
        const transition = document.startViewTransition(cb)
        // Safari will have an unhandled rejection if the transition
        // is aborted. Add a catch to ready.
        transition.ready.catch(noop)
        return transition.finished
    } else {
        cb()
        return Promise.resolve()
    }
}
